import { NgModule } from '@angular/core'

import { VerticalSearchComponent } from './vertical-search.component'
import { SharedModule } from '../shared.module'
import { CommonModule } from '@angular/common'

@NgModule({
  imports: [SharedModule, CommonModule],
  exports: [VerticalSearchComponent],
  declarations: [VerticalSearchComponent]
})
export class VerticalSearchModule {}
